export const queryNames = {
  CLIENTS: 'clients',
  BALANCE: 'balance',
  PAYMENTS: 'payments',
  USD_AMOUNT: 'usdAmount',
  PAYMENT_HISTORY: 'paymentHistory',
  PROFILE: 'profile',
}
